// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import {
  DEFAULT_NUMBER_ZERO,
  employeeColors,
  EMPTY_STRING,
  MAX_SIZE_FILE_UPLOAD,
  REG_EXP,
} from '~/utils/constants/common';
import { IFormEmployee } from '~/utils/interface/employee';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      avatarImage: yup
        .object()
        .shape({
          id: yup.string().trim().optional(),
          url: yup.string().trim().optional(),
          file: yup
            .mixed<File>()
            .optional()
            .test('fileSize', t('common_validate_file_size', { ns: 'common/base' }), (value) => {
              if (!value) return true;
              if (value && value?.size <= MAX_SIZE_FILE_UPLOAD) return true;
              return false;
            }),
        })
        .optional(),
      firstName: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      lastName: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      email: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' }))
        .test('isValidEmail', t('common_validate_invalid_email', { ns: 'common/base' }), (value) => {
          if (value && !REG_EXP.EMAIL.test(value)) return false;
          return true;
        }),
      phoneNumber: yup
        .string()
        .trim()
        .optional()
        .test('isValidPhone', t('common_validate_invalid_phone_number', { ns: 'common/base' }), (value) => {
          return !value || REG_EXP.PHONE_NUMBER.test(value);
        }),
      role: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      displayColor: yup.string().optional(),
    })
    .required();
};

export const defaultValuesForm: IFormEmployee = {
  avatarImage: {},
  firstName: EMPTY_STRING,
  lastName: EMPTY_STRING,
  email: EMPTY_STRING,
  phoneNumber: EMPTY_STRING,
  role: EMPTY_STRING,
  displayColor: employeeColors?.[DEFAULT_NUMBER_ZERO],
  hourlyRate: EMPTY_STRING,
  commissionRate: EMPTY_STRING,
};
